<template>
    <div>
        <div v-for="(item, i) in availableQuestions" :key="i" class="flex flex-col justify-between mb-4">
            <p class="mb-2">
                {{ item.question }}
                <AppModal v-if="item.modal">
                    <template #trigger>
                        <span class="cursor-pointer text-blue-light underline" v-html="item.modal.trigger" />
                    </template>
                    <template #contents>
                        <span v-html="item.modal.content"/>
                    </template>
                </AppModal>
            </p>
            <div class="pt-2 flex justify-evenly">
                <label v-for="(input, x) in item.answers" :key="x">
                    <input v-model="answers[i]"
                           @click="sendEvent(item.gaEvent[0], item.gaEvent[1],item.gaEvent[2] + ' - ' + input.title.toLowerCase())"
                           :value="input.value"
                           :name="item.name"
                           type="radio"
                           class="w-6 h-6 rounded-md bg-gray-100 mr-2"/>
                    {{ input.title }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import AppModal from "../AppModal";
export default {
    name: "SelfInstallQuestions",
    components: {AppModal},
    props: {
        questionsAndAnswers: {
            type: Array, // required format [{ name: '', question: '', answers: [{ title: '', value: true }]}]
            required: true,
        }
    },
    data: () => ({
        answers: [],
    }),
    watch: {
        answers(value) {
            this.$emit('answer', value)
        }
    },
    computed: {
        availableQuestions(){
            return this.questionsAndAnswers;
        }
    },
    methods: {},
}
</script>
